import type { Locale } from "@iso27001/shared";
import type { DocumentTranslation } from "../../api/docs.js";

export type Banner =
  | null
  | { kind: "germanOnly" }
  | { kind: "stale"; translated: string | null; original: string | null };

/**
 * Which notice, if any, belongs above a document.
 *
 * A pure function rather than JSX conditionals so it can be tested directly:
 * this package has no DOM environment (see src/i18n/trans.test.tsx), and the
 * interesting behaviour here is the decision, not the markup.
 *
 * Both notices are for a reader who asked for English. A German reader is on
 * the original — there is nothing missing and nothing stale about it — so they
 * see neither, even when a stale translation exists.
 */
export function bannerFor(requested: Locale, t: DocumentTranslation): Banner {
  if (requested !== "en") return null;
  if (!t.available) return { kind: "germanOnly" };
  if (t.stale) return { kind: "stale", ...t.stale };
  return null;
}
